import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../../../contexts/AppContext';
import useWarehouseStorageService from '../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorageDataForm } from '../../../../../app/models/WareHouseQuoteStorage';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import LazyLoading from '../../../../../components/LazyLoading';
import WarehouseQuoteStorageShowForm from './forms/WareHouseStorageForms/WareHouseStorageShowForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import DefaultCard from '../../../../../components/default/DefaultCard';
import useWarehouseQuoteRatesService from '../../../../../app/services/hooks/useWareHouseQuoteRateService';
import WarehouseQuoteRateShowForm from './forms/WareHouseRatesForms/WareHouseRatesShowForm';
import { WarehouseQuoteShowRateDataForm } from '../../../../../app/models/WareHouseQuoteRates';
import useWarehouseQuoteExpeditionService from '../../../../../app/services/hooks/useWareHouseQuoteExpeditionService';
import WarehouseExpeditionShowForm from './forms/WareHouseExpeditionForms/WareHouseExpeditionShowForm';
import { WarehouseExpedition } from '../../../../../app/models/WareHouseQuoteExpedition';
import useWarehouseQuoteExtraService from '../../../../../app/services/hooks/useWareHouseQuoteExtraServicesService';
import WarehouseExtraServicesShowForm from './forms/WareHouseExtraServicesForms/WareHouseExtraServicesShowForm';

interface Props {
    extraServiceId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseQuoteExtraServiceShow = ({
    extraServiceId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseExtraService,fetchingShowWarehouseExtraService} =
        useWarehouseQuoteExtraService();

    const [showExpedition, setShowExpedition] = useState<WarehouseQuoteShowRateDataForm>({});

    useEffect(() => {
        show();
    }, [extraServiceId]);

    const show = () => {
        showWarehouseExtraService(extraServiceId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowExpedition(response.data.extra_service);

                },

        });
    };

    return (

        <>
                        {!fetchingShowWarehouseExtraService ? (
                            <>
                                <WarehouseExtraServicesShowForm 
                                extraServiceDataForm={showExpedition}
                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}

        </>
    );
};

export default WarehouseQuoteExtraServiceShow;
